var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.arrayOfStoriesID.length > 0)?_c('div',{directives:[{name:"touch",rawName:"v-touch",value:({
      left: function () { return _vm.swipe('Left'); },
      right: function () { return _vm.swipe('Right'); },
      up: function () { return _vm.swipe('Up'); },
      down: function () { return _vm.swipe('Down'); }
    }),expression:"{\n      left: () => swipe('Left'),\n      right: () => swipe('Right'),\n      up: () => swipe('Up'),\n      down: () => swipe('Down')\n    }"}],attrs:{"height":"100%"}},[_c('singleStoryView',{attrs:{"singleStoryID":parseInt(_vm.getSelectedSingleStoryID)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }